import { useMemo } from 'react';

import { ReadonlyDetail } from '@/common/components/employees/shared/ReadonlyDetail';
import { EMPTY_DEFAULT } from '@/common/components/shared/table/constants';
import { useEmployeeDetailContext } from '@/common/contexts/EmployeeDetailContext';
import { EmployeeIdTypeLabels } from '@/common/types';
import { DateUtils } from '@/common/utils';

export const IdentificationDetails = () => {
  const { employeeDetail } = useEmployeeDetailContext();

  const { text: idIssuedDateText, isFuture: idIssuedDateIsFuture } = useMemo(
    () => DateUtils.getDifferenceString(employeeDetail.personalInformation.idIssuedDate),
    [employeeDetail.personalInformation.idIssuedDate],
  );
  const { text: idExpiryDateText, isFuture: idExpiryDateIsFuture } = useMemo(
    () => DateUtils.getDifferenceString(employeeDetail.personalInformation.idExpiryDate),
    [employeeDetail.personalInformation.idExpiryDate],
  );

  return (
    <div className="mb-6">
      <div className="mb-4 font-semibold">ID</div>
      <fieldset className="form-fieldset">
        <ReadonlyDetail label="ID Type">
          {employeeDetail.personalInformation.idType
            ? EmployeeIdTypeLabels[employeeDetail.personalInformation.idType]
            : null}
        </ReadonlyDetail>

        <ReadonlyDetail label="ID Number">{employeeDetail.personalInformation.idNumber}</ReadonlyDetail>

        <ReadonlyDetail label="ID Issued Place">{employeeDetail.personalInformation.idIssuedPlace}</ReadonlyDetail>

        <ReadonlyDetail label="ID Issued Date">
          {DateUtils.formatDate(employeeDetail.personalInformation.idIssuedDate) || EMPTY_DEFAULT}
          <div className="text-gray-7 text-xs">
            {idIssuedDateText}
            {!idIssuedDateIsFuture ? ' ago' : ''}
          </div>
        </ReadonlyDetail>

        <ReadonlyDetail label="ID Expiry Date">
          {DateUtils.formatDate(employeeDetail.personalInformation.idExpiryDate) || EMPTY_DEFAULT}
          <div className="text-gray-7 text-xs">
            {idExpiryDateText}
            {!idExpiryDateIsFuture ? ' ago' : ''}
          </div>
        </ReadonlyDetail>
      </fieldset>
    </div>
  );
};
